<template>
  <div class="select-ded-box">
    <el-dialog title="抵扣选择" :visible="true">
      <div
        style="
          height: 30px;
          width: 100%;
          text-align: left;
          line-height: 30px;
          padding-left: 10px;
          background-color: #f3f3f3;
        "
      >
        统计： 共{{ dedTotal.num }}件，计{{ dedTotal.amount }}元
      </div>
      <el-table :data="list">
        <el-table-column prop="goods_img" label="商品图片">
          <template slot-scope="scope">
            <div style="width: 50px; height: 50px">
              <img
                v-viewer
                style="width: 100%; height: 100%"
                :src="scope.row.goods_img[0]"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="cg_type"
          label="交易方式"
          align="center"
        ></el-table-column>
        <el-table-column prop="referer_type" label="来源"></el-table-column>
        <el-table-column prop="goods_name" label="商品名称"></el-table-column>
        <el-table-column prop="goods_no" label="商品货号"></el-table-column>
        <el-table-column prop="goods_kh" label="商品款号"></el-table-column>
        <el-table-column prop="price" label="代采单价"></el-table-column>
        <el-table-column prop="num" label="待抵扣">
          <template slot-scope="scope">
            {{ Number(scope.row.num) - Number(scope.row.used_num) }}
            /
            {{
              parseFloat(
                Number(scope.row.num - scope.row.used_num) *
                  Number(scope.row.price)
              ).toFixed(2)
            }}
          </template>
        </el-table-column>
        <el-table-column prop="goods_name" label="选择使用" width="150">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.used_num"
              size="mini"
              :min="0"
              :max="Number(scope.row.num)"
              :step="1"
              :step-strictly="true"
            >
            </el-input-number>
          </template>
        </el-table-column>
      </el-table>
      <div
        style="height: 40px; width: 100%; margin-top: 24px; position: relative"
      >
        <div style="position: absolute; right: 0">
          <div>
            <p />
            <p />
          </div>
          <div>
            <span
              >账单金额：共{{ anArr.num }}件，计{{
                anArr.amount
              }}
              &nbsp;&nbsp;&nbsp;&nbsp;{{ getDedTotal }}</span
            >
            &nbsp;&nbsp;
            <el-button size="mini" @click="closeDialog(1, { close: true })"
              >取 消</el-button
            >
            <el-button size="mini" type="primary" @click="submitDed"
              >确 定</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    ded_goods: {
      type: Array,
      default: [],
    },
    anArr: {
      type: Object,
      default() {
        return { num: 0, amount: 0.0 };
      },
    },
    used_ded: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      dedTotal: { num: 0, amount: 0.0 },
      list: [],
      dataObj: { num: 0, amount: 0.0 },
      selected_ded: [],
    };
  },
  computed: {
    getDedTotal() {
      const dedListTotal = { num: 0, amount: 0 };
      const data = [];
      const dataObj = { num: 0, amount: 0.0 };

      this.list.forEach((row, index) => {
        dedListTotal.num += Number(row.num);
        dedListTotal.amount += Number(row.num) * Number(row.price);
        if (Number(row.used_num) > 0) {
          const row_amount = Number(row.used_num) * Number(row.price);
          const _total_amout = dataObj.amount + row_amount;
          if (this.anArr.amount < _total_amout) {
            // emmmm 这个是为了input的变化准备的
            setTimeout((_) => row.used_num--, 100);
            return this.$message.e("选择的抵扣金额不能大于账单金额");
          }
          dataObj.num += Number(row.used_num);
          dataObj.amount += row_amount;

          data.push({
            woiid: row.woiid,
            num: row.used_num,
            referer_type: row.referer_type_index,
          });
        }
      });
      dedListTotal.amount = parseFloat(dedListTotal.amount).toFixed(2);
      this.dedTotal = dedListTotal;
      this.selected_ded = data;
      dataObj.amount = parseFloat(dataObj.amount).toFixed(2);
      this.dataObj = dataObj;
      return `选用抵扣：共${dataObj.num}件， 计${dataObj.amount}元`;
    },
  },
  mounted() {
    this.list = this.ded_goods;
    this.list.forEach((row, index) => {
      this.used_ded.forEach((v, i) => {
        if (
          row.referer_type_index == v.referer_type_index &&
          row.woiid == v.woiid &&
          v.num > 0
        ) {
          this.$set(this.list[index], "used_num", v.num);
        }
      });
    });
  },
  methods: {
    caculator(row, bool) {
      const num =
        Number(row.cg_sir_num) +
        Number(row.rj_sir_num) -
        Number(row.rj_out_num);
      const total = parseFloat(Number(row.price) * num).toFixed(2);
      if (bool) {
        return { num, total };
      }
      return `${num} / ${total}`;
    },
    submitDed() {
      const data = {
        ded_list: this.selected_ded,
        caculator_ded: this.dataObj,
        close: false,
      };
      this.closeDialog(0, data);
    },
    resetData() {
      this.selected_ded = [];
      this.list.forEach((row, index) => {
        this.list[index].used_num = 0;
      });
    },
    closeDialog(e, data = {}) {
      let mdata = data;
      if (e === 1) {
        this.resetData();
        mdata = {
          ded_list: [],
          close: true,
          caculator_ded: { num: 0, amount: 0 },
        };
      }
      this.$emit("closeDialog", mdata);
    },
  },
};
</script>

<style>
.select-ded-box .el-dialog__body {
  padding-top: 0 !important;
}

.select-ded-box .el-dialog__headerbtn {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/supplybill/components/SelectDedGoods.vue